import NavMenuCommon from "./NavMenuCommon";

export default function NavMenuMobile() {
  return (
    <div className="py-flash-050">
      <NavMenuCommon />
    </div>
  );
}
